var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-degular mx-auto pb-32 px-4 sm:px-8 md:px-10 min-h-screen contain h-auto flex flex-col bg-transparent overflow-visible"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }